import reduce from '../utils/reducers'
import d from '../utils/directives'
import store from 'src/store'
import Q_ from '../query'

export default function($api) {
  return {
    fetchAllEvents(featuredId) {
      let sort = { by: 'field', type: 'event', field: 'date', ascending: true }

      return Promise.all([
        $api.get({
          query: Q_(d.at.id(featuredId))
        }),
        $api.get({
          pageSize: 100,
          page: 1,
          query: Q_(d.at.type('event'), d.not.id(featuredId)).sort(sort)
        })
      ]).then(([ { results: featured }, { results: feed, total_pages: pages } ]) => {
        if (!featured.length || !feed.length) return Promise.reject()
        let { id, data, type } = featured[0]

        let res = {
          feed: { active: [], inactive: [] },
          featured: { id, ...reduce.content(data[type]) }
        }

        feed.forEach(({ id, data, type }) => {
          let evt = { id, ...reduce.content(data[type]) }
          if ((evt.date.valueOf() + (24 * 60 * 60 * 1000)) < Date.now()) return res.feed.inactive.unshift(evt)
          res.feed.active.push(evt)
        })

        if (pages <= 1) {
          store.commit('events/SET', res)
          return Promise.resolve(res)
        }

        return Promise.all([...Array(--pages).keys()].map(i => {
          return $api.get({
            pageSize: 100,
            page: i + 2,
            query: Q_(d.at.type('event'), d.not.id(featuredId)).sort(sort)
          })
        })).then(pages => {
          pages.forEach(page => {
            page.forEach(({ id, data, type }) => {
              let evt = { id, ...reduce.content(data[type]) }
              if ((evt.date.valueOf() + (24 * 60 * 60 * 1000)) < Date.now()) return res.feed.inactive.unshift(evt)
              res.feed.active.push(evt)
            })
          })

          store.commit('events/SET', res)
          return Promise.resolve(res)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/actions/events.js